import { OwnerQueueView } from './OwnerQueueView';

// SQA-66: Vince — Ops Handoffs queue.
export function VinceQueue(): JSX.Element {
  return (
    <OwnerQueueView
      slug="vince-handoff"
      displayName="Vince — Ops Handoffs"
      roleKey="operations"
    />
  );
}
